export default __webpack_public_path__ + "static/media/Recommended_Stefik_cse158-stefik.808b7ac0.pdf";